import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Text, CSkeleton } from '@appcues/component-library';
import styled from 'styled-components';
import { Icon } from 'next/components/ui';
import TrialMeter from 'components/Common/TrialMeter';
import { selectOverviewAnalytics } from 'reducers/analytics';
import { selectInstalledDomainsLoading } from 'reducers/account/installedDomains';
import { fetchOverviewAnalytics } from 'actions/analytics';

class NavTrialMeter extends Component {
  componentDidMount() {
    const { fetchOverviewAnalytics: fetchAnalytics } = this.props;
    fetchAnalytics();
  }

  render() {
    const {
      overviewAnalytics,
      flowsShownLimit,
      isInstalled,
      installedDomainsLoading,
    } = this.props;

    const normalizedFlowsShown =
      overviewAnalytics &&
      overviewAnalytics.data &&
      overviewAnalytics.data.flows_shown
        ? overviewAnalytics.data.flows_shown
        : 0;

    const exceededFlowsShownLimit = normalizedFlowsShown > flowsShownLimit;
    const flowPercentage = Math.round(
      (normalizedFlowsShown / flowsShownLimit) * 100,
      2
    );

    let meterColor;

    if (exceededFlowsShownLimit) {
      meterColor = '$red';
    } else if (flowPercentage > 75) {
      meterColor = '$yellow';
    } else {
      meterColor = '$purple';
    }

    if (
      installedDomainsLoading ||
      (isInstalled && !overviewAnalytics.meta.synced)
    ) {
      return <CSkeleton width="100%" height={25} />;
    }

    if (isInstalled) {
      return (
        <TrialDescription>
          <Text marginBottom={4}>
            {normalizedFlowsShown} of {flowsShownLimit} flows shown
          </Text>
          <TrialMeter
            flowPercentage={flowPercentage}
            color={meterColor}
            small
          />
        </TrialDescription>
      );
    }
    return (
      <InstallWrapper to="/settings/installation">
        <IconComponent icon="magic" />
        <InstallText className="install-text">
          <strong>Install</strong> to publish
        </InstallText>
      </InstallWrapper>
    );
  }
}

const TrialDescription = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 25px;
`;

const InstallWrapper = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-left: 25px;
  &:hover {
    .fa-magic {
      color: ${props => props.theme['$purple-dark']};
    }
    .install-text {
      color: ${props => props.theme['$gray-9']};
    }
  }
`;

const IconComponent = styled(Icon)`
  margin-left: 4px;
  margin-right: 16px;
  color: ${props => props.theme.$purple};
`;

const InstallText = styled.span`
  color: ${props => props.theme['$gray-7']};
`;

function mapStateToProps(state) {
  return {
    overviewAnalytics: selectOverviewAnalytics(state),
    installedDomainsLoading: selectInstalledDomainsLoading(state),
  };
}

export default connect(mapStateToProps, {
  fetchOverviewAnalytics,
})(NavTrialMeter);
